import React from 'react';
import { IconType, HudIcon } from '../Icons/HudIcons'; // Assuming HudIcon component exists
import {
  Container,
  StepContainer,
  Circle,
  ConnectingLine,
  StepContent,
  Title,
  Description,
  StepStatus
} from './Stepper.styles';

export type StepperStep = {
  title: string;
  description?: string | React.ReactNode; // Make description optional
  icon?: IconType;
  isTall?: boolean;
};

export interface StepperProps {
  steps: StepperStep[];
  currentStep: number; // 0-based index
}

function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <Container>
      {steps.map((step, index) => {
        const status = getCurrentStepStatus(index, currentStep);

        return (
          <React.Fragment key={index}>
            <StepContainer className={step.isTall ? 'tall' : ''}>
              <StepCircle step={step} status={status}/>
              <StepContent className='stepContent'>
                <Title status={status}>{step.title}</Title>
                {step.description && <Description>{step.description}</Description>}
              </StepContent>
            </StepContainer>
            {index !== steps.length - 1 && <ConnectingLine status={status} />}
          </React.Fragment>
        );
      })}
    </Container>
  );
}

function StepCircle({ step, status }: { step: StepperStep; status: StepStatus }) {
  const icon = status === StepStatus.COMPLETED ? 'other.check' : step.icon;
  return <Circle status={status} className="stepCircle">{icon && <HudIcon icon={icon} size="20px" />}</Circle>;
}

function getCurrentStepStatus(index: number, currentStep: number): StepStatus {
  if (index < currentStep) {
    return StepStatus.COMPLETED;
  }

  if (index === currentStep) {
    return StepStatus.CURRENT;
  }
  return StepStatus.INCOMPLETE;
}

export default Stepper;
